const defaultState = {};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    default:
      return state;
  }
};
